import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'sitemap',
  templateUrl: './sitemap.component.html',
  standalone: false,
})
export class SitemapComponent implements OnInit {
  constructor(private titleService: Title, public navigationService: NavigationService) {}
  ngOnInit(): void {
    this.titleService.setTitle('Mapa web');
  }
}
